import Grid2 from '@mui/material/Unstable_Grid2';
import { Step1 } from './components/Step1';
import { SelectCompany } from '../components/SelectCompany';
import { AfterConnection } from './components/AfterConnection';
import { type IntegrationProps } from '../../../Integration/hooks';
import useFactorialConnection from './hooks';
import { InfoBannerWithLink } from '../components/InfoBannerWithLink';
import { guideUrl } from './constants';

export const Factorial = (props: IntegrationProps) => {
  const { isLoading, setSelectedCompany, selectedCompany, isConnected } = useFactorialConnection();

  return (
    <Grid2>
      <Grid2 mb={2}>
        <InfoBannerWithLink guideUrl={guideUrl} />
      </Grid2>
      <Grid2 mb={4}>
        <SelectCompany setSelectedCompany={setSelectedCompany} />
      </Grid2>
      {selectedCompany && (
        <>
          <Grid2>
            <Step1 props={props} isLoading={isLoading} isConnected={isConnected} />
          </Grid2>

          {isConnected && <AfterConnection isConnected={isConnected} />}
        </>
      )}
    </Grid2>
  );
};
